import React from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import { withMenu } from '@bo-recoil/common/selector';
import LnbLeafMenu from './LnbLeafMenu';

const Container = styled(FlexBoxColumn)`
  width: 100%;
  background-color: ${boTheme.color.menu2};

  &:last-of-type {
    padding-bottom: 10px;
  }
`;

const LeafMenuGroupWrapper = styled(FlexBox)`
  width: 100%;
  height: 22px;
  font-size: ${boTheme.font.size.basic};
  font-weight: ${boTheme.font.weight.bold};
  color: ${boTheme.color.menu5};
`;

const LnbLeafMenuGroup = ({ leafMenuGroupNumber }) => {
  const leafMenuGroup = useRecoilValue(withMenu(leafMenuGroupNumber));

  return (
    <Container>
      <Spacing top={'10px'} />
      <LeafMenuGroupWrapper>
        <Spacing left={'24px'} />
        {leafMenuGroup.menuName}
      </LeafMenuGroupWrapper>
      {leafMenuGroup.menus?.map((leafMenuNumber) => (
        <LnbLeafMenu key={leafMenuNumber} leafMenuNumber={leafMenuNumber} />
      ))}
    </Container>
  );
};

LnbLeafMenuGroup.propTypes = {
  leafMenuGroupNumber: PropTypes.string,
};

export default LnbLeafMenuGroup;
